import type { SYSFormValidationValidators } from "../.."
import { ovl } from "../.."
import { T } from "../../textapi"
import type { SYSField, SYSFormState } from "./actions"

import type {
  OptionsValidateResultError,
  ValidateResultError,
  ValidationResetContext,
  ValidatorOptions,
} from "./validators"

import { _callValidator, _enrichValidation, _addValidation } from "./validators"

export const ValidationSummaryHandle = (
  valid: boolean,
  formState: SYSFormState,
  translationKey: string,
  translationReps?: any[],
  tab?: number
) => {
  let translationsRepsFixed = ["SYSSummary"].concat(translationReps)
  if (!valid) {
    ValidationSummaryAdd(formState, translationKey, translationsRepsFixed, tab)
  } else {
    ValidationSummaryRemove(formState, translationKey, tab)
  }
}

export const ValidationSummaryAdd = (
  formState: SYSFormState,
  translationKey: string,
  translationReps?: any[],
  tab?: number
) => {
  if (tab === undefined) {
    tab = 0
  }
  let translationRepsFixed = ["SYSSummary"].concat(translationReps)
  let summaryErrors = formState.validationResult[tab].summaryErrors
  summaryErrors[translationKey] = {
    translationKey,
    translationReps: translationRepsFixed,
  }
}

export const ValidationSummaryRemove = (
  formState: SYSFormState,
  translationKey: string,
  tab?: number
) => {
  if (tab === undefined) {
    tab = 0
  }
  let summaryErrors = formState.validationResult[tab].summaryErrors
  delete summaryErrors[translationKey]
}

export type AddValidationTypeOptions = {
  validation?: OptionsValidateResultError
  setFocus?: boolean
  dependents?: SYSField[]
}

// multi purpose ValidationAdd
export const ValidationsAdd = (
  fields: SYSField | SYSField[],
  translationKey: string,
  resetContext: ValidationResetContext,
  options?: AddValidationTypeOptions
) => {
  if (fields === undefined) {
    return
  }
  let fieldDefaultValidationOptions: OptionsValidateResultError = undefined
  if (!Array.isArray(fields)) {
    // we can just use validation defaults from Field if its a single field
    fields = [fields]
  }
  if (fields.length === 1) {
    fieldDefaultValidationOptions = fields[0].schema.defaultValidationOptions
  }
  let formState = ovl.getState().ovl.forms[fields[0].formType][fields[0].formId]
  let validation = _enrichValidation(
    formState,
    options?.validation,
    translationKey,
    resetContext,
    undefined,
    fieldDefaultValidationOptions
  )
  _addValidation(
    <SYSField[]>fields,
    validation,
    options?.setFocus,
    options?.dependents
  )
}

export const ValidatorAdd = (
  field: SYSField,
  validator: SYSFormValidationValidators,

  options?: ValidatorOptions
): boolean => {
  if (!options) {
    options = { val: undefined }
  }
  let validation = options?.validation
  let formState = ovl.getState().ovl.forms[field.formType][field.formId]
  let fieldDefaultValidationOptions: OptionsValidateResultError =
    field.schema.defaultValidationOptions
  validation = _enrichValidation(
    formState,
    validation,
    `SYSValidator${validator}`,
    undefined,
    undefined,
    fieldDefaultValidationOptions
  )
  options.validation = validation
  let res = _callValidator(validator, field, options)
  let fields = [field]
  if (res) {
    _addValidation(fields, validation, options.setFocus, options.dependents)
  }
  return !res
}

export const ValidationGetTranslation = (
  formState: SYSFormState,
  translationKey: string,
  translationReps: any[],
  involvedFieldKeys: string[],
  isMulti: boolean
) => {
  let existingTranslations = ovl.getState().ovl.language.translations
  if (isMulti) {
    let allFieldKeys = involvedFieldKeys
      .map((m) => formState.fields[m].ui.labelCaption)
      .join(",")
    let allPlaceholders = [allFieldKeys].concat(translationReps.toSpliced(0, 1))
    let tres
    let key
    if (involvedFieldKeys.length > 1) {
      key = `${translationKey}SummaryMulti`
    } else {
      key = `${translationKey}SummarySingle`
    }
    if (!existingTranslations[key]) {
      key = translationKey
    }
    tres = T(key, allPlaceholders)
    if (tres) {
      return tres
    }
  }
  let key = `${translationKey}SummarySingle`
  if (!existingTranslations[key]) {
    key = translationKey
  }
  return T(key, translationReps)
}

export const ValidatorCheck = (
  field: SYSField,
  validator: SYSFormValidationValidators,
  val?: any
): boolean => {
  let options: ValidatorOptions = { val, validation: { translationReps: [] } }
  return _callValidator(validator, field, options)
}
